import { defineStore } from 'pinia';
import { normalizePhoneNumber } from '../utils/phoneNumber';
import * as LoginApi from '../api/loginApi';
import Segment from '../Segment';
import { LoginError } from '../types/loginError';

interface LoginState {
  phoneNumber: string;
  error: string;
  loading: boolean;
  memberNotFound: boolean,
}

export const useLoginStore = defineStore('login', {
  state: (): LoginState => ({
    phoneNumber: '',
    error: '',
    loading: false,
    memberNotFound: false,
  }),
  getters: {
    normalizedPhoneNumber: state => normalizePhoneNumber(state.phoneNumber),
  },
  actions: {
    setPhoneNumber(phoneNumber: string) {
      this.phoneNumber = phoneNumber;
    },
    async login(riseupAccountId?: number, challenger?: boolean, memberId?: string) {
      if (challenger && riseupAccountId && memberId) {
        await Segment.identifyCustomer(riseupAccountId, memberId);
        Segment.trackUserGot('Login_Success');
      } else if (riseupAccountId) {
        await LoginApi.updateChallengesProduct();
        Segment.trackUserGot('Login_ChallengesProduct_Added');
      } else {
        Segment.trackUserGot('Login_NotACustomer');
        this.memberNotFound = true;
        throw Error(LoginError.MEMBER_NOT_FOUND);
      }
    },
  },
});
